"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var styles_1 = require("@material-ui/core/styles");
var slate_react_1 = require("slate-react");
var slate_1 = require("slate");
var core_1 = require("@material-ui/core");
var FormatBoldRounded_1 = __importDefault(require("@material-ui/icons/FormatBoldRounded"));
var FormatItalicRounded_1 = __importDefault(require("@material-ui/icons/FormatItalicRounded"));
var FormatUnderlinedRounded_1 = __importDefault(require("@material-ui/icons/FormatUnderlinedRounded"));
var StrikethroughSRounded_1 = __importDefault(require("@material-ui/icons/StrikethroughSRounded"));
var LinkRounded_1 = __importDefault(require("@material-ui/icons/LinkRounded"));
var EditorMarkButton_1 = __importDefault(require("../EditorMarkButton"));
var EditorToolbarButton_1 = __importDefault(require("../EditorToolbarButton"));
var withLinks_1 = require("../../plugins/withLinks");
var Portal = function (_a) {
    var children = _a.children;
    return react_dom_1.default.createPortal(children, document.body);
};
var useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        paper: {
            position: 'absolute',
            zIndex: 9999999,
            top: -10000,
            left: -10000,
            marginTop: -6,
            opacity: 0,
            // backgroundColor: '#222',
            borderRadius: 4,
            transition: 'opacity 0.25s',
        },
    });
});
var HoveringToolbar = function (_a) {
    var children = _a.children, _b = _a.controls, controls = _b === void 0 ? ['bold', 'underline', 'italic', 'strikethrough', 'link'] : _b;
    var ref = react_1.useRef();
    var editor = slate_react_1.useSlate();
    var classes = useStyles();
    react_1.useEffect(function () {
        var el = ref.current;
        var selection = editor.selection;
        if (!el) {
            return;
        }
        if (!selection ||
            !slate_react_1.ReactEditor.isFocused(editor) ||
            slate_1.Range.isCollapsed(selection) ||
            slate_1.Editor.string(editor, selection) === '') {
            el.removeAttribute('style');
            return;
        }
        console.log(selection);
        var domSelection = window.getSelection();
        var domRange = domSelection.getRangeAt(0);
        var rect = domRange.getBoundingClientRect();
        el.style.opacity = 1;
        el.style.top = rect.top + window.pageYOffset - el.offsetHeight + "px";
        el.style.left = rect.left + window.pageXOffset - el.offsetWidth / 2 + rect.width / 2 + "px";
    });
    function showControl(control) {
        return controls.includes(control);
    }
    return (react_1.default.createElement(Portal, null,
        react_1.default.createElement(core_1.Paper, { ref: ref, className: classes.paper },
            children,
            showControl('bold') && (react_1.default.createElement(EditorMarkButton_1.default, { format: "bold", alt: "Format bold", tooltip: "Bold", icon: react_1.default.createElement(FormatBoldRounded_1.default, null) })),
            showControl('italic') && (react_1.default.createElement(EditorMarkButton_1.default, { format: "italic", alt: "Format italic", tooltip: "Italic", icon: react_1.default.createElement(FormatItalicRounded_1.default, null) })),
            showControl('underline') && (react_1.default.createElement(EditorMarkButton_1.default, { format: "underline", alt: "Format underline", tooltip: "Underlined", icon: react_1.default.createElement(FormatUnderlinedRounded_1.default, null) })),
            showControl('strikethrough') && (react_1.default.createElement(EditorMarkButton_1.default, { format: "strikethrough", alt: "Format strikethrough", tooltip: "Strikethrough", icon: react_1.default.createElement(StrikethroughSRounded_1.default, null) })),
            showControl('link') && (react_1.default.createElement(EditorToolbarButton_1.default, { active: withLinks_1.isLinkActive(editor), onMouseDown: function (event) {
                    event.preventDefault();
                    var url = window.prompt('Enter the URL of the link:');
                    if (!url)
                        return;
                    withLinks_1.insertLink(editor, url);
                }, alt: "Insert a link", tooltip: "Insert a link" },
                react_1.default.createElement(LinkRounded_1.default, null))))));
};
exports.default = HoveringToolbar;
//# sourceMappingURL=EditorHoveringToolbar.js.map